import React, { useState, useEffect } from "react";
import { FaAngleLeft, FaAngleRight, FaDownload } from 'react-icons/fa';
import bajaj_ace from '/pdfimages/bajaj_ace.png';
import bajaj_awg from '/pdfimages/bajaj_awg.png';
import bajaj_etouch from '/pdfimages/bajaj_etouch.png';
import bajaj_magnum from '/pdfimages/bajaj_magnum.png';

const BajajAlliance = () => {
    const [selectedJob, setSelectedJob] = useState(null);
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const handleApplyClick = (job) => {
        setSelectedJob(job);
        setIsDrawerOpen(true);
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
        setSelectedJob(null);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevents the default form submission
    };
    const images = [
        {
            src: bajaj_ace,
            title: "Design Smarter",
            pdf: "/pdf/bajaj_ace.pdf",
            description: "BAJAJ ACE PLAN",
        },
        {
            src: bajaj_awg,
            title: "Build Faster",
            pdf: "/pdf/bajaj_awg.pdf",
            description: "AWG plan",
        },
    ];


    const images2 = [
        {
            src: bajaj_etouch,
            title: "Design Smarter",
            pdf: "/pdf/bajaj_etouch.pdf",
            description: "BAJAJ E TOUCH",
        },
    ];


    const images3 = [

        {
            src: bajaj_magnum,
            title: "Flexi Wealth Advantage Plan",
            pdf: "/pdf/bajaj_magnum.pdf",
            description: "Magnum Fortune Plus",
        },
    ];

    const [currentIndex1, setCurrentIndex1] = useState(0);
    const [currentIndex2, setCurrentIndex2] = useState(0);
    const [currentIndex3, setCurrentIndex3] = useState(0);
    const [isMobile, setIsMobile] = useState(false);


    useEffect(() => {
        // Detect screen size and set isMobile accordingly
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768); // 768px as breakpoint for mobile
        };

        window.addEventListener("resize", handleResize);
        handleResize(); // Run initially to set state based on the initial screen size

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);


    // Update handlers for each carousel
    const handleNext1 = () => setCurrentIndex1((prev) => (prev + 1) % images.length);
    const handlePrev1 = () => setCurrentIndex1((prev) => (prev - 1 + images.length) % images.length);

    const handleNext2 = () => setCurrentIndex2((prev) => (prev + 1) % images2.length);
    const handlePrev2 = () => setCurrentIndex2((prev) => (prev - 1 + images2.length) % images2.length);

    const handleNext3 = () => setCurrentIndex3((prev) => (prev + 1) % images3.length);
    const handlePrev3 = () => setCurrentIndex3((prev) => (prev - 1 + images3.length) % images3.length);

    const handleImageClick = (imageSrc) => {
        // Example: Open the image in a new tab
        window.open(imageSrc, "_blank");
    }

    return (
        <>
            <div className=" bg-gray-50">
                <div className="bg-darkBlue text-white py-12 px-6  text-center h-[45vh]">
                    <h1 className="text-4xl font-bold  pt-20">Bajaj Alliance</h1>
                    <p className="text-lg">
                        Secure your future with our exclusive insurance plans.
                    </p>
                </div>
            </div>

            {/* Guranteed Plan */}
            <div className="relative mt-20 w-full max-w-7xl mx-auto grid lg:grid-cols-2 gap-8 items-center">
                {/* Right Column: Carousel */}
                <div className="relative lg:order-last">
                    <div className="overflow-hidden">
                        <div
                            className="flex transition-transform duration-500 ease-in-out"
                            style={{
                                transform: `translateX(-${currentIndex1 * (isMobile ? 100 : 50)}%)`,
                            }}
                        >
                            {images.map((image, index) => (
                                <div
                                    key={index}
                                    className="w-full sm:w-full md:w-1/2 flex-shrink-0 px-2"
                                >
                                    <div className="relative">
                                        <img
                                            src={image.src}
                                            alt={`Slide ${index}`}
                                            className="w-full h-[50vh] md:h-[50vh] object-contain"
                                        />
                                        {/* Title and Description Overlay */}
                                        <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black to-transparent text-white">
                                            <p className="text-sm mb-2">{image.description}</p>
                                            {/* Buttons */}
                                            <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                                <button
                                                    onClick={() => handleApplyClick(image)}
                                                    className="w-full md:w-auto px-3 py-2 text-sm md:text-base font-medium border border-white text-white bg-darkBlue rounded-lg shadow hover:bg-blue-700 transition-all duration-200"
                                                >
                                                    BUY
                                                </button>
                                                <a
                                                    href={image.pdf} // Link to the PDF
                                                    target="_blank" // Open in a new tab
                                                    rel="noopener noreferrer" // Security best practices
                                                    className="flex items-center justify-center w-full md:w-auto px-4 py-2 text-sm md:text-base font-medium text-blue-600 bg-white border border-blue-600 rounded-lg shadow hover:bg-blue-100 focus:outline-none transition-all duration-200"
                                                >
                                                    <FaDownload className="mr-2" />
                                                    Download PDF
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Navigation Buttons */}
                    {images.length > 1 && (
                        <>
                            {/* Left Navigation Button */}
                            <button
                                className="absolute top-1/2 left-0 -translate-y-1/2 text-white p-2 rounded-full"
                                onClick={handlePrev1}
                            >
                                <FaAngleLeft style={{ fontSize: '25px' }} />
                            </button>

                            {/* Right Navigation Button */}
                            <button
                                className="absolute top-1/2 right-0 -translate-y-1/2 text-white p-2 rounded-full"
                                onClick={handleNext1}
                            >
                                <FaAngleRight style={{ fontSize: '25px' }} />
                            </button>

                            {/* Dots Navigation */}
                            <div className="flex justify-center mt-4 space-x-2">
                                {images.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setCurrentIndex1(index)}
                                        className={`w-3 h-3 rounded-full ${index === currentIndex1 ? "bg-blue-600" : "bg-gray-400"
                                            }`}
                                    ></button>
                                ))}
                            </div>
                        </>
                    )}
                </div>


                {/* Left Column: Text Content */}
                <div className="fflex flex-col justify-center px-4 md:px-6 lg:px-8 mx-auto max-w-7xl">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
                    Guarantee Saving Plan
                    </h1>
                    <p className="mt-4 text-base md:text-lg text-gray-700">This plan is ideal for individuals who seek to build a corpus for their future while being assured of guaranteed benefits. Below is a brief overview of the features and benefits of this plan:</p>

                </div>
            </div>

            {/* Term Plan */}
            <div className="relative mt-20 w-full max-w-7xl mx-auto grid lg:grid-cols-2 gap-8 items-center ">
                {/* Left Column: Carousel */}
                <div className="relative">
                    <div className="overflow-hidden">
                        <div
                            className="flex transition-transform duration-500 ease-in-out"
                            style={{
                                transform: `translateX(-${currentIndex2 * (isMobile ? 100 : 50)}%)`,
                            }}
                        >
                            {images2.map((image, index) => (
                                <div
                                    key={index}
                                    className="w-full sm:w-full md:w-1/2 flex-shrink-0 px-2"
                                >
                                    <div className="relative">
                                        <img
                                            src={image.src}
                                            alt={`Slide ${index}`}
                                            className="w-full h-[50vh] md:h-[50vh] object-contain"
                                        />
                                        {/* Title and Description Overlay */}
                                        <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black to-transparent text-white">
                                            <h3 className="text-lg font-bold">
                                                {/* {image.title} */}
                                            </h3>
                                            <p className="text-sm mb-2">
                                                {image.description}
                                            </p>
                                            {/* Button */}
                                            <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                                <button
                                                    onClick={() => handleApplyClick(image)}
                                                    className="w-full md:w-auto px-3 py-2 text-sm md:text-base font-medium border border-white text-white bg-darkBlue rounded-lg shadow hover:bg-blue-700 transition-all duration-200"
                                                >
                                                    BUY
                                                </button>
                                                <a
                                                    href={image.pdf} // Link to the PDF
                                                    target="_blank" // Open in a new tab
                                                    rel="noopener noreferrer" // Security best practices
                                                    className="flex items-center justify-center w-full md:w-auto px-4 py-2 text-sm md:text-base font-medium text-blue-600 bg-white border border-blue-600 rounded-lg shadow hover:bg-blue-100 focus:outline-none transition-all duration-200"
                                                >
                                                    <FaDownload className="mr-2" />
                                                    Download PDF
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Navigation Buttons */}
                    {images2.length > 1 && (
                        <>
                            {/* Left Navigation Button */}
                            <button
                                className="absolute top-1/2 left-0 -translate-y-1/2 text-white p-2 rounded-full"
                                onClick={handlePrev2}
                            >
                                <FaAngleLeft style={{ fontSize: '25px' }} />
                            </button>

                            {/* Right Navigation Button */}
                            <button
                                className="absolute top-1/2 right-0 -translate-y-1/2 text-white p-2 rounded-full"
                                onClick={handleNext2}
                            >
                                <FaAngleRight style={{ fontSize: '25px' }} />
                            </button>

                            {/* Dots Navigation */}
                            <div className="flex justify-center mt-4 space-x-2">
                                {images2.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setCurrentIndex2(index)}
                                        className={`w-3 h-3 rounded-full ${index === currentIndex2
                                            ? "bg-blue-600"
                                            : "bg-gray-400"
                                            }`}
                                    ></button>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                {/* Right Column: Text Content */}
                <div className="flex flex-col justify-center px-4 md:px-6 lg:px-8 mx-auto max-w-7xl">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
                        TERM PLAN
                    </h1>
                    <p className="mt-4 text-base md:text-lg text-gray-700">A Term Plan is a type of life insurance product that provides financial protection to your loved ones in the unfortunate event of your demise during the policy term. It is one of the simplest and most affordable forms of life insurance, offering high coverage at a relatively low premium.</p>

                </div>
            </div>

            {/* ULIP PLAN */}
            <div className="relative mt-20 w-full max-w-7xl mx-auto grid lg:grid-cols-2 gap-8 items-center mb-20">
                {/* Right Column: Carousel */}
                <div className="relative lg:order-last">
                    <div className="overflow-hidden">
                        <div
                            className="flex transition-transform duration-500 ease-in-out"
                            style={{
                                transform: `translateX(-${currentIndex3 * (isMobile ? 100 : 50)}%)`,
                            }}
                        >
                            {images3.map((image, index) => (
                                <div
                                    key={index}
                                    className="w-full sm:w-full md:w-1/2 flex-shrink-0 px-2"
                                >
                                    <div className="relative">
                                        <img
                                            src={image.src}
                                            alt={`Slide ${index}`}
                                            className="w-full h-[50vh] md:h-[50vh] object-contain"
                                        />
                                        {/* Title and Description Overlay */}
                                        <div className="absolute bottom-0 left-0 w-full p-4 bg-gradient-to-t from-black to-transparent text-white">
                                            {/* <h3 className="text-lg font-bold">
                                                {image.title}
                                            </h3> */}
                                            <p className="text-sm mb-2">
                                                {image.description}
                                            </p>
                                            {/* Button */}
                                            <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">
                                                <button
                                                    onClick={() => handleApplyClick(image)}
                                                    className="w-full md:w-auto px-3 py-2 text-sm md:text-base font-medium border border-white text-white bg-darkBlue rounded-lg shadow hover:bg-blue-700 transition-all duration-200"
                                                >
                                                    BUY
                                                </button>
                                                <a
                                                    href={image.pdf} // Link to the PDF
                                                    target="_blank" // Open in a new tab
                                                    rel="noopener noreferrer" // Security best practices
                                                    className="flex items-center justify-center w-full md:w-auto px-4 py-2 text-sm md:text-base font-medium text-blue-600 bg-white border border-blue-600 rounded-lg shadow hover:bg-blue-100 focus:outline-none transition-all duration-200"
                                                >
                                                    <FaDownload className="mr-2" />
                                                    Download PDF
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Navigation Buttons */}
                    {images3.length > 1 && (
                        <>
                            {/* Left Navigation Button */}
                            <button
                                className="absolute top-1/2 left-0 -translate-y-1/2 text-white p-2 rounded-full"
                                onClick={handlePrev3}
                            >
                                <FaAngleLeft style={{ fontSize: '25px' }} />
                            </button>

                            {/* Right Navigation Button */}
                            <button
                                className="absolute top-1/2 right-0 -translate-y-1/2 text-white p-2 rounded-full"
                                onClick={handleNext3}
                            >
                                <FaAngleRight style={{ fontSize: '25px' }} />
                            </button>

                            {/* Dots Navigation */}
                            <div className="flex justify-center mt-4 space-x-2">
                                {images3.map((_, index) => (
                                    <button
                                        key={index}
                                        onClick={() => setCurrentIndex3(index)}
                                        className={`w-3 h-3 rounded-full ${index === currentIndex3
                                            ? "bg-blue-600"
                                            : "bg-gray-400"
                                            }`}
                                    ></button>
                                ))}
                            </div>
                        </>
                    )}
                </div>

                {/* Left Column: Text Content */}
                <div className="flex flex-col justify-center px-4 md:px-6 lg:px-8 mx-auto max-w-7xl">
                    <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
                        ULIP
                    </h1>
                    <p className="mt-4 text-base md:text-lg text-gray-700">It offers you a life cover while also allowing you to invest in various market-linked investment funds, such as equity, debt, or hybrid funds. The premium you pay is split between providing life cover and investing in these funds, offering the potential for wealth creation over time.</p>

                </div>
            </div>

            {isDrawerOpen && (
                <>

                    {/* Transparent Background */}
                    <div
                        className="fixed inset-0 bg-black bg-opacity-50 z-40"
                        onClick={closeDrawer} // Close the popup when clicking outside
                    ></div>

                    {/* Popup */}
                    <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-11/12 max-w-3xl bg-white shadow-lg rounded-lg z-50 overflow-hidden flex flex-col md:flex-row">

                        <button
                            onClick={() => {
                                closeDrawer(); // Close the popup
                               
                            }}
                            className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-xl"
                        >
                            ✖
                        </button>
                        
                        {/* Left Side: Image */}
                        <div className="w-full md:w-1/3 h-40 md:h-auto bg-cover bg-center" style={{ backgroundImage: `url(https://images.pexels.com/photos/7821911/pexels-photo-7821911.jpeg?auto=compress&cs=tinysrgb&w=600)` }}>
                        </div>

                        {/* Right Side: Form Content */}
                        <div className="w-full md:w-2/3 p-4 md:p-6">
                            <h2 className="text-xl md:text-2xl font-bold mb-2 md:mb-4">{selectedJob.description}</h2>
                            <p className="text-gray-600 mb-4">Please fill out the form to buy this plan</p>
                            <form onSubmit={handleFormSubmit} className="space-y-3 md:space-y-4">
                                <div>
                                    <label htmlFor="name" className="block font-medium text-gray-700">
                                        Name
                                    </label>
                                    <input
                                        type="text"
                                        id="name"
                                        name="name"
                                        required
                                        className="w-full border rounded-lg p-2 mt-1"
                                        placeholder="Enter your full name"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="email" className="block font-medium text-gray-700">
                                        Email
                                    </label>
                                    <input
                                        type="email"
                                        id="email"
                                        name="email"
                                        required
                                        className="w-full border rounded-lg p-2 mt-1"
                                        placeholder="Enter your email"
                                    />
                                </div>
                                <div>
                                    <label htmlFor="contactNumber" className="block font-medium text-gray-700">
                                        Contact Number
                                    </label>
                                    <input
                                        type="tel"
                                        id="contactNumber"
                                        name="contactNumber"
                                        required
                                        className="w-full border rounded-lg p-2 mt-1"
                                        placeholder="Enter your contact number"
                                    />
                                </div>
                                <div className="flex flex-col md:flex-row justify-end gap-2">
                                    <button
                                        type="button"
                                        onClick={closeDrawer}
                                        className="w-full md:w-auto px-4 py-2 border rounded-lg text-gray bg-skyBlue hover:bg-gray-100"
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        className="w-full md:w-auto px-4 py-2 bg-darkBlue text-white rounded-lg"
                                    >
                                        Submit Application
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </>
            )}


        </>
    );
};

export default BajajAlliance;




